const Mixin = {
	methods: {
		lazyImg:function(imgUrl){
			return  imgUrl
		}
	}
}
export default Mixin



// WEBPACK FOOTER //
// ./src/common/js/mixin.js